import React from 'react';
import CustomAutocomplete from './CustomAutocomplete/CustomAutocomplete';
import { FilterCollapsableWrapper } from '../../../../components/Filters/FiltersWrappers/FilterCollapsableWrapper/FilterCollapsableWrapper';

interface AutocompleteProps {
  filterType: string;
  disableScroll?: boolean;
  noBottomDivider?: boolean;
}

export const Autocomplete = ({ filterType, noBottomDivider }: AutocompleteProps) => {
  return (
    <>
      <FilterCollapsableWrapper
        filterType={filterType}
        noBottomDivider={noBottomDivider}
      >
        <CustomAutocomplete
          filterType={filterType}
        />
      </FilterCollapsableWrapper>
    </>
  );
};
